import { GoogleTagManager as NextGoogleTagManager } from '@next/third-parties/google';

import { ClientConfig } from 'services/clientConfig';

export const GoogleTagManager = () => {
  const clientConfig = ClientConfig.getInstance().getConfig();

  return (
    <NextGoogleTagManager
      gtmId={clientConfig.googleTagManagerId}
      nonce={clientConfig.nonce || undefined}
    />
  );
};
